import React, { Component, useRef } from "react";
import { TextField, } from "@material-ui/core"
import List from "@material-ui/core/List";
import successIcon from "../../../../Assets/img/svg/Check.svg"
import errorIcon from "../../../../Assets/img/svg/cancelerror.svg"
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../Assets/jss/customStyle";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import API from "../../../../helpers/endpointService";
import { Radio, RadioGroup, FormControlLabel, Checkbox, } from "@material-ui/core";
import { CssTextField } from "../../../custom/textField";
import { inspectionSystem } from "../../../Constants";
import { warningAlert, successAlert } from "../../../custom/alert"
import { errorToast } from "../../../../actions/CommonFunction";



class ListViewOPD extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      successId: 0,
      isSuccess: false,
      isFailure: false,
      isSuccessComment: false,
      isFailureComment: false,
      CommentId: "",
      InspectionId: 0,
      ShipId: 0,
      User: "",
      OperComments: "",
      MainConComments: "",
      AuxiliaryConComments: "",
      LubeConComments: "",
      ClassSurveyComments: "",
      SurveyComments: "",
      OperName: [],
      MainCon: [],
      AuxiliaryCon: [],
      LubeCon: [],
      ClassSurvey: [],
      Survey: [],
      isMobile: false,
    };
  }

  componentDidMount() {
    this.state.User = localStorage.getItem("UserRoles");
    this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.state.ShipId = parseInt(localStorage.getItem("DashId"));
    this.setState({});
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    this.dataTable();
    this.MainFuelTable();
    this.AuxiliaryTable();
    this.LubeOilTable();
    this.ClassSurveyTable();
    this.SurveyTable();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#OPER1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Operation1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#Operation").addClass("d-none");
    $("#Operation").removeClass("d-block");
    $("#OPAL").removeClass("active-color");
    $("#OPAT").removeClass("fw-bolder");
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }

  }

  resize1 = () => {
    $("#OPER1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#Operation").removeClass("d-none");
    $("#Operation").addClass("d-block");
    $("#OPAL").addClass("active-color");
    $("#OPAT").addClass("fw-bolder");
  }

  sidebar = () => {
    this.props.navigate("/sidebar");
  };

  OpenPopup = () => {
    window.$("#deletepopup").modal("show");
  };
  handleInputChange = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.OperName && this.state.OperName?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.CheckId = e.target.value : ""
    ))
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: parseInt(e.target.value),
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: "",
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data);
    } else {
      this.put_operationalStatus(data, data?.Id)
    }
  }
  handleInputChange5 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.ClassSurvey && this.state.ClassSurvey?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.CheckId = e.target.value : ""
    ))
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: parseInt(e.target.value),
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: "",
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data);
    } else {
      this.put_operationalStatus(data, data?.Id)
    }
  }
  handleInputChange6 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.Survey && this.state.Survey?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.CheckId = e.target.value : ""
    ))
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: parseInt(e.target.value),
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId == null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: "",
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data);
    } else {
      this.put_operationalStatus(data, data?.Id)
    }
  }
  handleInputChange1 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.OperName && this.state.OperName?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    this.setState({})
  }
  updatemastercomments = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: e.target.value.trim(),
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data)
    } else {
      this.put_operationalStatus(data, data.Id)
    }
  }
  /* Operation data comments code  */
  handleInputCommentChange = (e, field) => {
    if (field === "operationaldata") {
      this.state.OperComments = e.target.value;
    } else if (field === "maincondition") {
      this.state.MainConComments = e.target.value;
    } else if (field === "AuxiliaryCondition") {
      this.state.AuxiliaryConComments = e.target.value;
    } else if (field === "LubeCondition") {
      this.state.LubeConComments = e.target.value;
    } else if (field === "ClassSurvey") {
      this.state.ClassSurveyComments = e.target.value;
    } else if (field === "Survey") {
      this.state.SurveyComments = e.target.value;
    }
    this.state.CommentId=field;
    this.setState({})
  }
  updateOperationalComments = (e, field) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let shipId = parseInt(this.state.ShipId)
    let data = {
      shipId: shipId,
      sectionId: 0,
      comments: "",
      modifiedBy: currentUser.email
    }
    if (field === "operationaldata") {
      data.sectionId = inspectionSystem.OperationalDataCondition;
      data.comments = this.state.OperComments;
    } else if (field === "maincondition") {
      data.sectionId = inspectionSystem.MainEngineFuelConsumption;
      data.comments = this.state.MainConComments;
    } else if (field === "AuxiliaryCondition") {
      data.sectionId = inspectionSystem.AuxiliaryEngineFuelConsumption;
      data.comments = this.state.AuxiliaryConComments;
    } else if (field === "LubeCondition") {
      data.sectionId = inspectionSystem.LubeOilConsumption;
      data.comments = this.state.LubeConComments;
    } else if (field === "ClassSurvey") {
      data.sectionId = inspectionSystem.ClassSurveys;
      data.comments = this.state.ClassSurveyComments;
    } else if (field === "Survey") {
      data.sectionId = inspectionSystem.Survey;
      data.comments = this.state.SurveyComments;
    }
    this.UpdateChecklistComments(data)
  }
  UpdateChecklistComments = (data) => {
    let apiUrl = `${API.AddEdit_checklist_comments}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({ isSuccessComment: true })
          this.GetOperationComments()
          this.GetMainComments();
          this.GetAuxiliaryComments();
          this.GetLubeComments();
          this.GetClassSurveyComments();
          this.GetSurveyComments();
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
          setTimeout(() => {
            this.setState({ isSuccessComment: false, CommentId: 0, })
          }, 3000);

        } else {
          this.setState({ isFailureComment: true })
          setTimeout(() => {
            this.setState({ isFailureComment: false, CommentId: 0 })
          }, 4000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        this.setState({ isFailureComment: true })
        setTimeout(() => {
          this.setState({ isFailureComment: false, CommentId: 0 })
        }, 4000);
        if (error?.response?.status === 401) {
        }
      });
  }
  GetOperationComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.OperationalDataCondition}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.OperComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  GetMainComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.MainEngineFuelConsumption}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.MainConComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  GetAuxiliaryComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.AuxiliaryEngineFuelConsumption}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.AuxiliaryConComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  GetClassSurveyComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.ClassSurveys}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.ClassSurveyComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  GetLubeComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.LubeOilConsumption}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.LubeConComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  GetSurveyComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.Survey}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.SurveyComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }

  handleInputChange2 = (e, str, Id, Name) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    var data = {
      Id: 0,
      CategoryId: Id,
      CategoryName: Name,
      AnswerLookupList: [{ Id: 0, "Answer": e.target.value }],
    }
    this.state.MainCon && this.state.MainCon?.Questions?.map((i, ind) => (
      i.QuestionId == str.QuestionId ?
        (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data) :
          (i?.AnswersList1.length > 0) ?
            i?.AnswersList1?.map((a, indexs) => a.CategoryId === Id ? a.AnswerLookupList[0].Answer = e.target.value : i?.AnswersList1.push(data))
            : i?.AnswersList1.push(data) : ""
    ))
    this.state.MainCon?.Questions.map((i) => (
      i.AnswersList?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      }),
      i.AnswersList1?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      })
    ))
    this.setState({})
  }

  handleInputChange3 = (e, str, Id, Name) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    console.log(e.target.value, str, Id, Name)
    var data = {
      Id: 0,
      CategoryId: Id,
      CategoryName: Name,
      AnswerLookupList: [{ Id: 0, "Answer": e.target.value }],
    }
    this.state.AuxiliaryCon && this.state.AuxiliaryCon?.Questions?.map((i, ind) => (
      i.QuestionId == str.QuestionId ?
        (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data) :
          (i?.AnswersList1.length > 0) ?
            i?.AnswersList1?.map((a, indexs) => a.CategoryId === Id ? a.AnswerLookupList[0].Answer = e.target.value : i?.AnswersList1.push(data))
            : i?.AnswersList1.push(data) : ""
    ))
    this.state.AuxiliaryCon && this.state.AuxiliaryCon?.Questions?.map((i) => (
      i.AnswersList.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      }),
      i.AnswersList1.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      })
    ))
    this.setState({})
    // console.log(str.QuestionId, Id, Name)
    // this.state.AuxiliaryCon && this.state.AuxiliaryCon?.Questions?.map((i, index) => (
    //   i.QuestionId == str.QuestionId ?
    //     i?.AnswersList1.map((a, indexs) => (
    //       (a.CategoryId === Id || a.CategoryName == Name) ? a.AnswerLookupList[0].Answer = e.target.value : ""
    //     )) : ""
    // ));
    // this.setState({})
  }
  handleInputChange4 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.LubeCon && this.state.LubeCon?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    this.setState({})
  }

  handleInputChange8 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    this.state.Survey && this.state.Survey?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    this.setState({})
  }

  handleInputChange7 = (e, str, Id, Name, index) => {
    this.state.successId = str.QuestionId;
    this.setState({})
    var data = {
      CategoryId: Id,
      CategoryName: Name,
      AnswerLookupList: [{ Id: 0, "Answer": e.target.value }],
    }
    this.state.Survey && this.state.Survey?.Questions?.map((i, ind) => (
      i.QuestionId == str.QuestionId ?
        (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data) :
          (i?.AnswersList1.length > 0) ?
            i?.AnswersList1?.map((a, indexs) => a.CategoryId === Id ? a.AnswerLookupList[0].Answer = e.target.value : i?.AnswersList1.push(data))
            : i?.AnswersList1.push(data) : ""
    ))
    this.state.Survey && this.state.Survey?.Questions?.map((i) => (
      i.AnswersList?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      }),
      i.AnswersList1?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      })
    ))
    this.setState({})
  }

  updatemastercomments2 = (e, str, Id, AnswerId) => {
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: (AnswerId === null || AnswerId === undefined) ? 0 : AnswerId,
      AnswerCategory: Id,
      Answer: e.target.value.trim(),
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data)
    } else {
      this.put_operationalStatus(data, data.Id)
    }
  }

  updatemastercomments1 = (e, str, Id) => {
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: e.target.value.trim(),
      MultipleAnswerIds: "",
      CreatedBy: this.state.User
    }
    if (data.Id === 0) {
      this.post_operationalStatus(data)
    } else {
      this.put_operationalStatus(data, data.Id)
    }
  }

  post_operationalStatus = (data) => {
    let apiUrl = `${API.AddEdit_checklist}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.setState({ isSuccess: true })
          this.dataTable();
          this.MainFuelTable();
          this.AuxiliaryTable();
          this.LubeOilTable();
          this.ClassSurveyTable();
          this.SurveyTable();
          setTimeout(() => {
            if(this.state.isSuccess===true){
            this.setState({ isSuccess: false, successId: 0, })}
          }, 2000);
        } else {
          this.setState({ isFailure: true })
          setTimeout(() => {
            if(this.state.isFailure===true){
            this.setState({ isFailure: false, successId: 0 })}
          }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        this.setState({ isFailure: true })
        setTimeout(() => {
          if(this.state.isFailure===true){
          this.setState({ isFailure: false, successId: 0 })}
        }, 3000);
        if (error?.response?.status === 401) {
        }
      });
  }
  put_operationalStatus = (data, Id) => {
    let apiUrl = `${API.AddEdit_checklist}?id=${Id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        // this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.setState({ isSuccess: true })
          this.dataTable();
          this.MainFuelTable();
          this.AuxiliaryTable();
          this.LubeOilTable();
          this.ClassSurveyTable();
          this.SurveyTable();
          setTimeout(() => {
            if(this.state.isSuccess===true){
            this.setState({ isSuccess: false, successId: 0 })
          }
          }, 2000);
        } else {
          this.setState({ isFailure: true })
          setTimeout(() => {
            if(this.state.isFailure===true){
            this.setState({ isFailure: false, successId: 0 })
            }
          }, 3000);
        }
      })
      .catch((error) => {
        this.setState({ isFailure: true })
        setTimeout(() => {
          if(this.state.isFailure===true){
          this.setState({ isFailure: false, successId: 0 })
          }
        }, 3000);
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

        }
      });
  };

  dataTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.OperationalDataCondition}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            OperName: response.data,
          }, () => {
            $.each(this.state.OperName?.Questions, function (i, val) {
              $(".operation input[value='" + val.CheckId + "']").prop('checked', true);
            });
            this.GetOperationComments()
          });
          // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };

  MainFuelTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.MainEngineFuelConsumption}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            MainCon: response?.data,
          });
          this.state.MainCon.Questions.map((i) => (
            i.AnswersList.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            })
          ))
          this.setState({}, () => {
            this.GetMainComments()
          })
          // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  AuxiliaryTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.AuxiliaryEngineFuelConsumption}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            AuxiliaryCon: response?.data,
          });
          this.state.AuxiliaryCon.Questions.map((i) => (
            i.AnswersList.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            })
          ))
          this.setState({}, () => {
            this.GetAuxiliaryComments()
          })
          // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  LubeOilTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.LubeOilConsumption}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            LubeCon: response?.data,
          }, () => {
            this.GetLubeComments()
          });
          // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  ClassSurveyTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.ClassSurveys}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            ClassSurvey: response?.data,
          },
            () => {
              $.each(this.state.ClassSurvey?.Questions, function (i, val) {
                $(".operationalsurvey input[value='" + val.CheckId + "']").prop('checked', true);
              });
              this.GetClassSurveyComments()
            }
          );
          this.state.ClassSurvey?.Questions.map((i) => (
            i?.AnswersList?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i?.AnswersList1?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            })
          ))
          // this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  SurveyTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.Survey}&inspectionId=${this.state.InspectionId}`;
    // this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            Survey: response?.data,
          }, () => {
            $.each(this.state.Survey?.Questions, function (i, val) {
              $(".survey input[value='" + val.CheckId + "']").prop('checked', true);
            });
            this.GetSurveyComments()
          });
          this.state.Survey?.Questions?.map((i) => (
            i.AnswersList?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            })
          ))
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  AddCancel1 = () => {
    this.props.navigate(`/shiplist`)
  }
  render() {
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 border-bottom mt-4 mob-topfixed">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}>
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"OPER" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="OPER"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Operational Data </h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
                ? "calc(100% - 240px)"
                : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}>
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%">
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div
            className="row"
            style={{ margin: this.state.isMobile ? "" : "5px" }}>
            <div className="row px-3">
              <div className="col-12 pt-2">
                {this.state.isMobile ? <></> : <h6>Operational Data </h6>}
              </div>
            </div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="6">
                        <span className="spandoc-thead">
                          {this.state.OperName.SubsectionName}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.OperName && this.state.OperName?.Questions?.map((i, ind) => (
                      <>
                        <tr className="border-top operation" onMouseEnter={() => this.setState({ HoverId: i.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                          <td width="5%" className="border-right text-center align-middle"><span className="spandoc-td">{i.OrderId}</span> </td>
                          <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td1" : "docwidth-td1"} border-right align-middle`}>
                            <span className="spandoc-td">{i.QuestionDescription}</span>
                          </td>
                          {i.AnswerType === 11 ? (<>
                            {i?.AnswerLookupList != null && i?.AnswerLookupList?.length > 0 ?
                              <>
                                <td className="spanstatusnormal-thead align-middle">
                                  <div className="spandoc-td">
                                    {i.AnswerLookupList.map((v_i, index) => (
                                      <label style={{ color: "#000000", padding: 5 }}><input type="radio" className="checkboxradio" name={`muhRadio${i.QuestionId}`} id={`Generalyes${i.QuestionId}`} value={v_i.Id} onClick={(e) => { this.handleInputChange(e, i) }} style={{ color: "rgba(0, 0, 0, 0.54)" }} /><span className="checkboxtext" style={{ verticalAlign: "top" }}>{v_i.Answer}</span></label>
                                    ))
                                    }
                                  </div>
                                </td>
                              </> : <></>
                            }
                          </>) : (
                            <td className="commentsrequire-td align-middle">
                              <span className="spandoc-td">
                                <CssTextField
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  onChange={(e) => this.handleInputChange1(e, i)}
                                  onBlur={(e) => this.updatemastercomments(e, i)}
                                  value={i?.Answer}
                                  InputProps={{
                                    className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                  }}
                                />
                              </span>
                            </td>)
                          }
                          <td width="4%" className="border-right text-center align-middle">{i.QuestionId === this.state.successId && this.state.isSuccess === true ?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                            {i.QuestionId === this.state.successId && this.state.isFailure === true ? <span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                        </tr>
                      </>))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={3}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{
                            className: `border-radius mt-1 ${classes.inputfieldAlign}`,
                            style: { fontSize: 12 }
                          }}
                          value={this.state.OperComments}
                          type="text"
                          onChange={(e) => this.handleInputCommentChange(e, "operationaldata")}
                          onBlur={(e) => this.updateOperationalComments(e, "operationaldata")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"operationaldata" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"operationaldata" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
            <div className="row px-3"></div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"}>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="7">
                        <span className="spandoc-thead">
                          {this.state?.MainCon?.SubsectionName}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr className="border-top">
                      <td
                        width="5%" className="border-right text-center align-middle">
                        {" "}S.No{" "}
                      </td>
                      <td
                        width="50%"
                        className="border-right text-center align-middle">
                        {" "}
                        Engine Order
                      </td>

                      <td className="border-right text-center align-middle">
                        RPM
                      </td>
                      <td className="border-right text-center align-middle">
                        Ballast Consumption (mt/24hrs)
                      </td>
                      <td className="border-right text-center align-middle">
                        Loaded Speed (knots)
                      </td>
                      <td className="text-center align-middle">
                        Loaded Consumption (mt/24hrs)
                      </td>

                    </tr>
                    {this.state.MainCon && this.state.MainCon?.Questions?.map((j, ind) => (<>
                      <tr
                        className="border-top"
                        onMouseEnter={() => this.setState({ HoverId: j.Id })} onMouseLeave={() =>
                          this.setState({ HoverId: 0 })
                        }
                      >
                        <td className="border-right text-center align-middle">
                          <span className="spandoc-td">{j.OrderId}</span>
                        </td>
                        <td
                          className={`${window.innerWidth < 1080
                            ? "docwidthmobile-td1"
                            : "docwidth-td1"
                            } border-right align-middle`}
                          width="50%"
                        >
                          <span className="spandoc-td">
                            {j.QuestionDescription}
                          </span>
                        </td>
                        <td className="commentsrequire-td2 align-middle border-right">
                          <span className="spandoc-td">
                            <CssTextField
                              multiline
                              fullWidth
                              variant="outlined"
                              type="text"
                              onChange={(e) => this.handleInputChange2(e, j, j?.AnswersList[0]?.CategoryId, j?.AnswersList[0]?.CategoryName)}
                              onBlur={(e) => this.updatemastercomments2(e, j, j?.AnswersList[0]?.CategoryId, j?.AnswersList1?.filter((i) => i.CategoryName === "RPM")[0]?.AnswerLookupList[0].Id)}
                              value={j?.AnswersList1 != null && j?.AnswersList1?.filter((i) => i.CategoryName === "RPM")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((i) => i.CategoryName === "RPM")[0]?.AnswerLookupList[0]?.Answer : ""}
                              InputProps={{
                                className: `border-radius padding-space ${classes.inputfieldAlign}`,
                              }}
                            />
                          </span>
                        </td>
                        <td className="commentsrequire-td2 align-middle border-right">
                          <span className="spandoc-td">
                            <CssTextField
                              multiline
                              fullWidth
                              variant="outlined"
                              type="text"
                              onChange={(e) => this.handleInputChange2(e, j, j?.AnswersList[1]?.CategoryId, j?.AnswersList[1]?.CategoryName)}
                              onBlur={(e) => this.updatemastercomments2(e, j, j?.AnswersList[1]?.CategoryId, j?.AnswersList1?.filter((i) => i.CategoryName === "Ballast Consumption (mt/24hrs)")[0]?.AnswerLookupList[0].Id)}
                              value={j?.AnswersList1 != null && j?.AnswersList1?.filter((i) => i.CategoryName === "Ballast Consumption (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((i) => i.CategoryName === "Ballast Consumption (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer : ""}
                              InputProps={{
                                className: `border-radius padding-space ${classes.inputfieldAlign}`,
                              }}
                            />

                          </span>
                        </td>
                        <td className="commentsrequire-td2 align-middle border-right">
                          <span className="spandoc-td">
                            <CssTextField
                              multiline
                              fullWidth
                              variant="outlined"
                              type="text"
                              onChange={(e) => this.handleInputChange2(e, j, j?.AnswersList[2]?.CategoryId, j?.AnswersList[2]?.CategoryName)}
                              onBlur={(e) => this.updatemastercomments2(e, j, j?.AnswersList[2]?.CategoryId, j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Speed (knots)")[0]?.AnswerLookupList[0].Id)}
                              value={j?.AnswersList1 != null && j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Speed (knots)")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Speed (knots)")[0]?.AnswerLookupList[0]?.Answer : ""}
                              InputProps={{
                                className: `border-radius padding-space ${classes.inputfieldAlign}`,
                              }}
                            />

                          </span>
                        </td>
                        <td className="commentsrequire-td2 align-middle">
                          <span className="spandoc-td">
                            <CssTextField
                              multiline
                              fullWidth
                              variant="outlined"
                              type="text"
                              onChange={(e) => this.handleInputChange2(e, j, j?.AnswersList[3]?.CategoryId, j?.AnswersList[3]?.CategoryName)}
                              onBlur={(e) => this.updatemastercomments2(e, j, j?.AnswersList[3]?.CategoryId, j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Consumption (mt/24hrs)")[0]?.AnswerLookupList[0].Id)}
                              value={j?.AnswersList1 != null && j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Consumption (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((i) => i.CategoryName === "Loaded Consumption (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer : ""}
                              InputProps={{
                                className: `border-radius padding-space ${classes.inputfieldAlign}`,
                              }}
                            />

                          </span>
                        </td>
                        <td width="4%" className="border-right text-center align-middle">{j.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {j.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                      </tr>
                    </>))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={6}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{ className: `border-radius mt-1 ${classes.inputfieldAlign}`, style: { fontSize: 12 } }}
                          value={this.state.MainConComments}
                          onChange={(e) => this.handleInputCommentChange(e, "maincondition")}
                          onBlur={(e) => this.updateOperationalComments(e, "maincondition")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"maincondition" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"maincondition" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row px-3"></div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="6">
                        <span className="spandoc-thead">
                          {this.state?.AuxiliaryCon?.SubsectionName}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-top">
                      <td
                        width="5%"
                        className="border-right text-center align-middle">
                        {" "}
                        S.No{" "}</td>
                      <td
                        width="50%"
                        className="border-right text-center align-middle">
                        Engines Running{" "}
                      </td>
                      <td className="border-right text-center align-middle">
                        In Port Consumption Loading (mt/24hrs)
                      </td>
                      <td className="text-center align-middle">
                        In Port Consumption Discharging (mt/24hrs)
                      </td>
                    </tr>
                    {this.state?.AuxiliaryCon && this.state.AuxiliaryCon?.Questions?.map((k, ind) => (
                      <>

                        <tr
                          className="border-top"
                          onMouseEnter={() => this.setState({ HoverId: k.Id })} onMouseLeave={() =>
                            this.setState({ HoverId: 0 })
                          }>
                          <td className="border-right text-center align-middle">
                            <span className="spandoc-td">{k.OrderId}</span>
                          </td>
                          <td
                            className={`${window.innerWidth < 1080
                              ? "docwidthmobile-td1"
                              : "docwidth-td1"
                              } border-right align-middle`}
                            width="50%"
                          >
                            <span className="spandoc-td">
                              {k.QuestionDescription}
                            </span>
                          </td>
                          <td className="commentsrequire-td1 align-middle border-right">
                            <span className="spandoc-td">
                              <CssTextField
                                multiline
                                fullWidth
                                variant="outlined"
                                type="text"
                                onChange={(e) => this.handleInputChange3(e, k, k?.AnswersList[0]?.CategoryId, k?.AnswersList[0]?.CategoryName)}
                                onBlur={(e) => this.updatemastercomments2(e, k, k?.AnswersList[0]?.CategoryId, k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Loading (mt/24hrs)")[0]?.AnswerLookupList[0].Id)}
                                value={k?.AnswersList1 != null && k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Loading (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer ? k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Loading (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer : ""}
                                InputProps={{
                                  className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                }}
                              />

                            </span>
                          </td>
                          <td className="commentsrequire-td1 align-middle">
                            <span className="spandoc-td">
                              <CssTextField
                                multiline
                                fullWidth
                                variant="outlined"
                                type="text"
                                onChange={(e) => this.handleInputChange3(e, k, k?.AnswersList[1]?.CategoryId, k?.AnswersList[1]?.CategoryName)}
                                onBlur={(e) => this.updatemastercomments2(e, k, k?.AnswersList[1]?.CategoryId, k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Discharging (mt/24hrs)")[0]?.AnswerLookupList[0].Id)}
                                value={k?.AnswersList1 != null && k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Discharging (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer ? k?.AnswersList1?.filter((i) => i.CategoryName === "In Port Consumption Discharging (mt/24hrs)")[0]?.AnswerLookupList[0]?.Answer : ""}
                                InputProps={{
                                  className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                }}
                              />

                            </span>
                          </td>
                          <td width="4%" className="border-right text-center align-middle">{k.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {k.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                        </tr>
                      </>))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={4}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{ className: `border-radius mt-1 ${classes.inputfieldAlign}`, style: { fontSize: 12 } }}
                          value={this.state.AuxiliaryConComments}
                          onChange={(e) => this.handleInputCommentChange(e, "AuxiliaryCondition")}
                          onBlur={(e) => this.updateOperationalComments(e, "AuxiliaryCondition")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"AuxiliaryCondition" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"AuxiliaryCondition" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row px-3"></div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"}>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="6">
                        <span className="spandoc-thead">
                          {this.state?.LubeCon?.SubsectionName}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-top">
                      <td
                        width="5%"
                        className="border-right text-center align-middle">
                        {" "}
                        S.No{" "}
                      </td>
                      <td
                        width="50%"
                        className="border-right text-center align-middle">
                        {" "}
                        Machinery
                      </td>
                      <td className=" text-center align-middle">
                        Consumption (liters /24hrs)
                      </td>
                    </tr>
                    {this.state.LubeCon && this.state.LubeCon?.Questions?.map((l) => (
                      <>
                        <tr
                          className="border-top"
                          onMouseEnter={() => this.setState({ HoverId: l.Id })} onMouseLeave={() =>
                            this.setState({ HoverId: 0 })}>
                          <td className="border-right text-center align-middle">
                            <span className="spandoc-td">{l.OrderId}</span>
                          </td>
                          <td
                            className={`${window.innerWidth < 1080
                              ? "docwidthmobile-td1" : "docwidth-td1"} border-right align-middle`}
                            width="50%">
                            <span className="spandoc-td">
                              {l.QuestionDescription}
                            </span>
                          </td>
                          <td className="commentsrequire-td align-middle">
                            <span className="spandoc-td">
                              <CssTextField
                                multiline
                                fullWidth
                                variant="outlined"
                                type="text"
                                onChange={(e) => this.handleInputChange4(e, l)}
                                onBlur={(e) => this.updatemastercomments1(e, l)}
                                value={l?.Answer}
                                InputProps={{
                                  className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                }}
                              />

                            </span>
                          </td>
                          <td width="4%" className="border-right text-center align-middle">{l.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {l.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                        </tr>
                      </>
                    ))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={3}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{ className: `border-radius mt-1 ${classes.inputfieldAlign}`, style: { fontSize: 12 } }}
                          value={this.state.LubeConComments}
                          onChange={(e) => this.handleInputCommentChange(e, "LubeCondition")}
                          onBlur={(e) => this.updateOperationalComments(e, "LubeCondition")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"LubeCondition" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"LubeCondition" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row px-3"></div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"}>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top  section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="6">
                        <span className="spandoc-thead">{this.state?.ClassSurvey?.SubsectionName}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.ClassSurvey && this.state.ClassSurvey?.Questions?.map((m) => (
                      <tr
                        className="border-top operationalsurvey"
                        onMouseEnter={() => this.setState({ HoverId: m.Id })} onMouseLeave={() =>
                          this.setState({ HoverId: 0 })
                        } >
                        <td width="5%" className="border-right text-center align-middle">
                          <span className="spandoc-td">{m?.OrderId}</span>
                        </td>
                        <td
                          className={`${window.innerWidth < 1080
                            ? "docwidthmobile-td1"
                            : "docwidth-td1"
                            } border-right align-middle`}
                          width="50%">
                          <span className="spandoc-td">
                            {m.QuestionDescription}
                          </span>
                        </td>
                        {m?.AnswerLookupList != null && m?.AnswerLookupList?.length > 0 ?
                          <>
                            <td className="spanstatusnormal-thead  align-middle">
                              <div className="spandoc-td">
                                {m.AnswerLookupList.map((v_i, index) => (
                                  <label style={{ color: "#000000", padding: 5 }}><input type="radio" className="checkboxradio" name={`muhRadio${m.QuestionId}`} id={`Generalyes${m.QuestionId}`} value={v_i.Id} onClick={(e) => { this.handleInputChange(e, m) }} style={{ color: "rgba(0, 0, 0, 0.54)" }} /><span className="checkboxtext" style={{ verticalAlign: "top" }}>{v_i.Answer}</span></label>
                                ))
                                }
                              </div>
                            </td>
                          </> : <></>
                        }
                         <td width="4%" className="border-right text-center align-middle">{m.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {m.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                      </tr>
                    ))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={3}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{ className: `border-radius mt-1 ${classes.inputfieldAlign}`, style: { fontSize: 12 } }}
                          value={this.state.ClassSurveyComments}
                          onChange={(e) => this.handleInputCommentChange(e, "ClassSurvey")}
                          onBlur={(e) => this.updateOperationalComments(e, "ClassSurvey")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"ClassSurvey" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"ClassSurvey" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row px-3"></div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"}>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="table-active">
                      <th width="3%" className="border-right">
                        <span className="spandoc-thead">S.No</span>
                      </th>
                      <th width="50%" className="border-right">
                        <span className="spandoc-thead">Survey</span>
                      </th>
                      <th className="comments require-td border-right">
                        <span className="spandoc-thead">
                          Date Last Completed
                        </span>
                      </th>
                      <th className="comments require-td">
                        <span className="spandoc-thead">Date Next Due</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.Survey && this.state.Survey?.Questions?.map((n) => (<>
                      <tr
                        className="border-top survey"
                        onMouseEnter={() => this.setState({ HoverId: n.Id })} onMouseLeave={() =>
                          this.setState({ HoverId: 0 })
                        }>
                        <td className="border-right text-center align-middle">
                          <span className="spandoc-td">{n.OrderId}</span>
                        </td>
                        <td
                          className={`${window.innerWidth < 1080
                            ? "docwidthmobile-td"
                            : "docwidth-td"
                            } border-right align-middle`}
                          width="49%">
                          <span className="spandoc-td">
                            {n.QuestionDescription}
                          </span>
                        </td>
                        {n.AnswerType === 11 ? (<>
                          {n?.AnswerLookupList != null && n?.AnswerLookupList?.length > 0 ?
                            <>
                              <td className="spanstatusnormal-thead align-middle" colSpan={2}>
                                <div className="spandoc-td">
                                  {n.AnswerLookupList.map((v_i, index) => (
                                    <label style={{ color: "#000000", padding: 5 }}><input type="radio" className="checkboxradio" name={`muhRadio${n.QuestionId}`} id={`Generalyes${n.QuestionId}`} value={v_i.Id} onClick={(e) => { this.handleInputChange(e, n) }} style={{ color: "rgba(0, 0, 0, 0.54)" }} /><span className="checkboxtext" style={{ verticalAlign: "top" }}>{v_i.Answer}</span></label>
                                  ))
                                  }
                                </div>
                              </td>
                            </> : <></>
                          }</>) : (
                          <>
                            {n.AnswersList !== null ? (<>
                              <td className="commentsrequire-td1 align-middle border-right">
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="text"
                                    onChange={(e) => this.handleInputChange7(e, n, n?.AnswersList[0]?.CategoryId, n?.AnswersList[0]?.CategoryName)}
                                    onBlur={(e) => this.updatemastercomments2(e, n, n?.AnswersList[0]?.CategoryId, n?.AnswersList1?.filter((i) => i.CategoryName === "Date Last Completed")[0]?.AnswerLookupList[0].Id)}
                                    value={n?.AnswersList1 != null && n?.AnswersList1?.filter((i) => i.CategoryName === "Date Last Completed")[0]?.AnswerLookupList[0]?.Answer ? n?.AnswersList1?.filter((i) => i.CategoryName === "Date Last Completed")[0]?.AnswerLookupList[0]?.Answer : ""}
                                    InputProps={{
                                      className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                    }}
                                  />
                                </span>
                              </td>
                              <td className="commentsrequire-td1 align-middle">
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="text"
                                    onChange={(e) => this.handleInputChange7(e, n, n?.AnswersList[1]?.CategoryId, n?.AnswersList[1]?.CategoryName)}
                                    onBlur={(e) => this.updatemastercomments2(e, n, n?.AnswersList[1]?.CategoryId, n?.AnswersList1?.filter((i) => i.CategoryName === "Date Next Due")[0]?.AnswerLookupList[0].Id)}
                                    value={n?.AnswersList1 != null && n?.AnswersList1?.filter((i) => i.CategoryName === "Date Next Due")[0]?.AnswerLookupList[0]?.Answer ? n?.AnswersList1?.filter((i) => i.CategoryName === "Date Next Due")[0]?.AnswerLookupList[0]?.Answer : ""}
                                    InputProps={{
                                      className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                    }}
                                  />
                                </span>
                              </td>
                            </>) : (<>
                              <td className="commentsrequire-td1 align-middle" colSpan={2}>
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="text"
                                    onChange={(e) => this.handleInputChange8(e, n)}
                                    onBlur={(e) => this.updatemastercomments(e, n)}
                                    value={n?.Answer}
                                    InputProps={{
                                      className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                    }}
                                  />

                                </span>
                              </td>
                            </>)}
                          </>)}
                          <td width="4%" className="border-right text-center align-middle">{n.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {n.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                      </tr>
                    </>))}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={4}>
                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                        <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                          InputProps={{ className: `border-radius mt-1 ${classes.inputfieldAlign}`, style: { fontSize: 12 } }}
                          value={this.state.SurveyComments}
                          onChange={(e) => this.handleInputCommentChange(e, "Survey")}
                          onBlur={(e) => this.updateOperationalComments(e, "Survey")} />
                      </td>
                      <td width="4%" className="border-right text-center align-middle">{"Survey" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"Survey" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewOPD))
);
